import gql from '_/utils/gql'

export const relationshipQl = (name: string) => `
  ${name} {
    data {
      attributes {
        title
        slug
      }
    }
  }
`

export const imageDataGql = gql`
  data {
      id
      attributes {
          width
          height
          alternativeText
          url
          ext
          provider
          size
          mime
          caption
          hash
          formats
          previewUrl
          name
      }
  }
`
export const imageQl = () => `
  image {
    ${imageDataGql}
  }
`

export const heroImageQl = () => `
  heroImage{
    ${imageDataGql}
  }
`

export const paginationQl = () => `
  pagination {
    total
    pageCount
    pageSize
    page
  }
`
